module.exports = __webpack_public_path__ + "static/media/PM17.387280d6.png";